import React, { useEffect, useState } from "react";
import Header from "./Header/Header";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";
import {
  disableContextMenu,
  disableShortcuts,
  disableCopyPaste,
} from "../Student/EventHandlers";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";

import LayoutCopyRight from "../ReusableComponents/LayoutCopyright";
const NCLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const isActive = (path) => location.pathname.includes(path);
  useEffect(() => {
    if (items?.userTypeId === 4) {
      document.addEventListener("contextmenu", disableContextMenu);
      document.addEventListener("keydown", disableShortcuts);
      document.addEventListener("cut", disableCopyPaste);
      document.addEventListener("copy", disableCopyPaste);
      document.addEventListener("paste", disableCopyPaste);
      return () => {
        document.removeEventListener("keydown", disableShortcuts);
        document.removeEventListener("cut", disableCopyPaste);
        document.removeEventListener("copy", disableCopyPaste);
        document.removeEventListener("paste", disableCopyPaste);
      };
    }
  }, []);

  const onIdle = () => {
    alert("Your session has been expired. Please re-login");
    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
    navigate("/Login", { replace: true });
  };

  useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * parseInt(process.env.REACT_APP_SESSIONIDELTIMEOUT),
  });
  const [YearHide, SetYearHide] = useState(false);
  return (
    <>
      {/* <div style={{ display: "grid", gridTemplateRows: "auto 1fr", height: "100vh", }} >
        <Header />
        <Outlet />
      </div> */}

      {/* {items?.userTypeId !== 4 ? (
        <div className="dflex" style={{ minHeight: "100vh" }}>
          <div className="w-100" style={{ position: "fixed", top: "0", zIndex: "1000" }} >
            <Header />
          </div>
          <div style={{ flex: "1", marginTop: "127px" }}>
            <ToastContainer />
            <Outlet />
          </div>
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateRows: "auto 1fr", height: "100vh", }} >
          <Header />
          <Outlet />
          <ToastContainer />
        </div>
      )} */}

      {items?.userTypeId !== 4 ? (
        <div className="dfleyx " style={{ display: "grid", gridTemplateRows: "auto 1fr", minHeight: "100vh" }}>
          <div className="w-100" style={{ position: "sticky", top: "0", zIndex: "1000" }} >
            <Header YearH={YearHide} />
          </div>
          <div style={{ flex: "1" }}>
            <Outlet context={{ YH: SetYearHide }} />
            <ToastContainer />
          </div>
          {!isActive("/PrincipleDashboard") && <LayoutCopyRight />}
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateRows: "auto 1fr", height: "100vh", }} >
          <Header />
          <Outlet />
          <ToastContainer />
        </div>
      )}
    </>
  );
};
export default NCLayout;
